// extracted by mini-css-extract-plugin
module.exports = {"margin-top":"HomePageMsg_margin-top__1a8w2","success-message":"HomePageMsg_success-message__2SbOP","user-msg":"HomePageMsg_user-msg__3UGC1"};